<div class="widget-title">Average Purchase Time</div>
<div class="chartContainer">
<div *ngIf="!noData"[innerHTML]="dynamicContent" class="avgTime"></div>
<div *ngIf="noData" class="noData">No Data Available</div>
</div>
